<ng-container *ngIf="appEnabled">
    <ng-container *ngIf="!isAccessDenied; else blueScreen">
        <router-outlet></router-outlet>
    </ng-container>
    <ng-template #blueScreen>
        <div class="blue-screen">
        </div>
    </ng-template>

</ng-container>
<ng-container *ngIf="!appEnabled">
    <app-loading-page></app-loading-page>
</ng-container>